import React from 'react'

type Props = {
  open: boolean
  title?: string
  message: string
  confirmText?: string
  cancelText?: string
  onConfirm: () => void
  onCancel: () => void
}

const ConfirmModal: React.FC<Props> = ({ open, title, message, confirmText = 'Yes', cancelText = 'No', onConfirm, onCancel }) => {
  if (!open) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50" onClick={onCancel} />
      <div className="relative w-full max-w-md bg-white dark:bg-surface-dark rounded shadow p-6 z-10">
        {title && <h3 className="text-lg font-semibold mb-2">{title}</h3>}
        <div className="mb-4 text-sm text-subtext-light">{message}</div>
        <div className="flex justify-end gap-2">
          <button onClick={onCancel} className="px-4 py-2 rounded bg-background-light">{cancelText}</button>
          <button onClick={onConfirm} className="px-4 py-2 rounded bg-alert-red text-white">{confirmText}</button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmModal
